
export default [
    // signup route with optional refererral link
    {
        path: '/settings',
        name: 'settings.index',
        component: () => import(/* webpackChunkName: "about" */ '@/views/settings/index.vue'),
        meta: {
            layout: 'dashboard'
        },
        children: [
            {
                path: '',
                name: 'settings.index',
                component: () => import(/* webpackChunkName: "about" */ '@/views/settings/index.vue'),
                meta: {
                    layout: 'dashboard'
                }
            }
        ]
    }
]
